import { store } from '../manager/DataManager';

export const HP = store.createStore(100);
